import { Core } from "@faire/design-tokens";
import { Span } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const OptionalFieldLabel = () => {
  return (
    <Span color={Core.text.subdued}>
      {" "}
      <StrictLocalMsg
        defaultMessage="(optional)"
        description={{
          text: "Indicating that a form section is not required for completion",
          img: "https://cdn.faire.com/fastly/327d904b989af889d22ef2470d97c3d2f0d212947581f8444b3f15e515e82054.png",
        }}
      />
    </Span>
  );
};
